export default __webpack_public_path__ + "static/media/sushinakazawa.00d30412.jpeg";